import $ from 'jquery';
import PL_utils from '../patterns/pl-utils.js';

function ss() {
  $(window).on('load', function () {
    const url = window.location.href;
    const ww = $(window).width();
    const isEDMode = url.indexOf('ed=1') > -1;

    // ED mode
    if (isEDMode) {
      const body = document.querySelector('body');
      const headerBar = document.querySelector('.header-bar');

      PL_utils.addClass('edmode', body);

      if (url.indexOf('/edit-listing') > -1) {
        PL_utils.removeClass('hidden', document.querySelector('.svg-pending'));
        document.querySelector('#edit-status').innerText = 'PENDING ADD';
        document.querySelector('#edit-address').value = '123 Main Street';
        document.querySelector('#edit-address-state').innerHTML += '<option value="CA">California</option>';
        document.querySelector('#edit-address-state').value = 'CA';
        document.querySelector('#edit-city').value = 'Beverly Hills';
        document.querySelector('#edit-zipcode').value = '90210';
        document.querySelector('#edit-phone').value = '5555555555';
        PL_utils.addClass('hidden', document.querySelector('.map-placeholder'));
        PL_utils.removeClass('hidden', document.querySelector('.map-container'));
        const mapImage = new this.Image();
        mapImage.src = '/assets/img/shared/mapPlaceHolder2.png';
        document.querySelector('.map').appendChild(mapImage);
      }

      //error state for all forms
      if (url.indexOf('error=1') > -1) {
        if (url.indexOf('/') > -1) {
          $('#validate-credentials').click();
          if (document.getElementById('npi')) {
            document.getElementById('npi').style.caretColor = 'transparent'; 
            document.getElementById('npi').blur(); 
          }
        }
        if (url.indexOf('/add-listing') > -1) {
          $('#add-listing-submit').click();
          document.getElementById('add-address').blur(); 
        }
        if (url.indexOf('/edit-listing') > -1) {
          const inputs = document.querySelectorAll('input, select');
          inputs.forEach((element) => {
              element.value = "";
          });
          $('#edit-listing-submit').click();
          document.getElementById('edit-address').blur();
        }
        if (url.indexOf('/unsubscribe') > -1) {
          $('#submit-unsubscribe').click();
          document.getElementById('email').blur();
        }
      }

      if(url.indexOf('/edit-listing') > -1 && url.indexOf('map=1') > -1) {
        const setPinButton = document.getElementById("edit-map-pin");
        const correctPinButton = document.getElementById("set-map-pin");
        PL_utils.addClass('hidden', setPinButton);
        PL_utils.addClass('active', correctPinButton);
      }

      if(url.indexOf('/faqs') > -1) {
        if (url.indexOf('accordions=1') > -1) {
          document.querySelectorAll('.accordion-wrapper').forEach((item) => {
            PL_utils.addClass('open', item);
          });
        }
      }

      if(url.indexOf('/terms-of-conditions') > -1) {
      }

      if (url.indexOf('sign-in=1') > -1) {
        if (headerBar) {
            PL_utils.removeClass('hidden', document.querySelector('.treatment-provider'));
            PL_utils.removeClass('hidden', document.querySelector('.hcp-type'));
            PL_utils.removeClass('hidden', document.querySelector('.npi-number'));
            PL_utils.removeClass('hidden', document.querySelector('.dea-number'));
            PL_utils.addClass('hidden', document.querySelector('#user-details-loading'));
            PL_utils.removeClass('hidden', headerBar);
        }
      }

      if(url.indexOf('/verify-email') > -1 && url.indexOf('fullTerms') > -1) {
        const terms = document.querySelector('.terms-of-use-scrollable');
        terms.style.height = 'auto';
        terms.style.overflow = 'hidden';
      }

      //Cookies banner
      if (window.location.href.indexOf('cookieBanner') > -1) {
        setTimeout(() => {
          document.querySelector('html').style.overflow = 'visible';
        }, 5000);
        document.querySelector('body').classList.add('cookies');
      }
      if (window.location.href.indexOf('cookieBannerHover') > -1) {
        document.querySelector('body').classList.add('cookies-hover');
      }
      if (window.location.href.indexOf('cookieBannerFocus') > -1) {
        document.querySelector('body').classList.add('cookies-focus');
      }
      if (window.location.href.indexOf('cookieBannerRejected') > -1) {
        setTimeout(() => {
          document.querySelectorAll('.ot-tgl input').forEach(e => {
            e.click();
          })
        }, 5000)
      }
      if (window.location.href.indexOf('cookieBannerExpanded') > -1) {
        document.querySelector('body').classList.add('cookies-expanded');
        setTimeout(() => {
          document.querySelectorAll('button[ot-accordion="true"]').forEach(e => {
            e.click();
          })
        }, 5000)
      }
    }
  });
}

export default () => {
  ss();
};